import BattleActions from '../../battle-data/battle-actions.js'
import {MenuOption} from '../../../menu-engine/MenuOption'
import {setBattleValue} from '../../../redux-actions/battle-actions.js'

/* Get a dynamic list of MenuOption models for Special or Items (pass in the type) */
export function getSubmissionActionOptionsData(playerModel, type="") {

  let payload = {};

  //Filter (don't filter out PP though)
  playerModel.getAvailableActions({
    filterForPp: false
  }).filter(action => {

    const model = BattleActions[action.actionId];

    //First, check for Supers (doesnt use string match)
    if (type === "supers") {
      return model.isSuper
    }

    //Filter by supplied type. Looks at ID of the special. (naming convention prefix)
    if (type === "special" && !model.isSuper && action.actionId.match(/^special_/)) {
      return true
    }
    if (type === "items" && action.actionId.match(/^item_/)) {
      return true;
    }
    return false;

  }).forEach((action, index) => {
      const model = BattleActions[action.actionId];
      const optionKey = `option-${type}-${index}`;

      //console.log(playerModel.name, model.ppCost, playerModel.pp)
      const hasEnoughPp = model.ppCost <= playerModel.pp;


      let metaSpot = "";
      if (model.ppCost > 0) {
        metaSpot = `PP ${model.ppCost}`;
      }



      // const isStolen = model.isItem &&

      payload[optionKey] = new MenuOption({
        label: model.name,
        description: model.description,
        isUnavailable() {
          return !hasEnoughPp
        },
        viewBag: {

          index: index, //For scroll anchoring behavior

          //Only things that UI might want to show
          metaData: metaSpot,

          ppCost: model.ppCost,
          hasEnoughPp: hasEnoughPp,
          isStolen: action.isStolen || false,

          //TODO: check for stolen data here before providing the actionCategory.
          actionCategory: action.isStolen ? "stolen-item" : model.category //provides the string to use for getting an icon

        },
        nextView: "targetsView",

        handleOptionEnter() {
          //Populate the node in state with our selected action!
          setBattleValue({
            arenaSubmissionMenuAction: {
              ...BattleActions[action.actionId],
              id: action.actionId,
              actionMeta: action //include the actionMeta from our player state (the attacks I know, and Items with instanceIds)
            }
          })
        }
      }, optionKey)
    });

    //Add a back button to the home screen
    payload["listview-back"] = new MenuOption({
      label: "Back",
      description: "Back to previous menu",
      viewBag: {
        index: Object.keys(payload).length, //one more than the last option (for scrolly behavior)
        isBackButton: true
      },
      nextView: "homeView"
    }, "listview-back");

    return payload;
}



// WEBPACK FOOTER //
// ./src/battle/ArenaView/SubmissionMenu/getSubmissionMenuDataListView.js